const fusos = [
  {fuso: '-3.00', value: '(GMT -3:00) Brasil, Buenos Aires, Georgetown'},
  {fuso: "-2.00", value: '(GMT -2:00) Brasil, Fernando de Noronha, Trindade e Martim Vaz'},
  {fuso: "-4.00", value: '(GMT -4:00) Brasil, Manaus, Cuiaba, Mato Grosso, Mato Grosso do Sul, Roraima, Rondônia, Amazonas e Acre'},
  {fuso: '-12.00', value: '(GMT -12:00) Eniwetok, Kwajalein'},
  {fuso: '-11.00', value: '(GMT -11:00) Ilhas Centrais, Samoa,'},
  {fuso: '-10.00', value: '(GMT -10:00) Havaí'},
  {fuso: '-9.00', value: '(GMT -9:00) Alasca'},
  {fuso: '-8.00', value: '(GMT -8:00) Tempo do Pacífico (EUA &amp; Canadá)'},
  {fuso: '-7.00', value: '(GMT -7:00) Tempo Montês (EUA &amp; Canadá)'},
  {fuso: '-6.00', value: '(GMT -6:00) Tempo Central(EUA &amp; Canadá), Cidadedo México'},
  {fuso: '-5.00', value: '(GMT -5:00) Tempo Oriental (EUA &amp; Canadá),Bogotá, Lima,'},
  {fuso: '-4.50', value: '(GMT -4:30) Caracas'},
  {fuso: '-4.00', value: '(GMT -4:00) Tempo do Atlântico (Canadá), Caracas, LaPaz,'},
  {fuso: '-3.50', value: '(GMT -3:30) Newfoundland'},
  {fuso: '-2.00', value: '(GMT -2:00) Meio-Atlântico'},
  {fuso: '-1.00', value: '(GMT -1:00 hora) Açores, Ilhas de Cabo Verde,'},
  {fuso: '0.00', value: '(GMT) Tempo da Europa Ocidental, Londres, Lisboa,Casablanca'},
  {fuso: '1.00', value: '(GMT +1:00 hora) Bruxelas, Copenhague, Madrid, Paris'},
  {fuso: '2.00', value: '(GMT +2:00) Kaliningrad, África do Sul'},
  {fuso: '3.00', value: '(GMT +3:00) Bagdá, Riyadh, Moscou, St. Petersburg'},
  {fuso: '3.50', value: '(GMT +3:30) Teerã'},
  {fuso: '4.00', value: '(GMT +4:00) Abu Dabi, Muscat, Baku, Tbilisi,'},
  {fuso: '4.50', value: '(GMT +4:30) Kabul'},
  {fuso: '5.00', value: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi,Tashkent'},
  {fuso: '5.5', value: '(GMT +5:30) Bombay, Calcutá, Madras, Nova Delhi'},
  {fuso: '5.75', value: '(GMT +5:45) Kathmandu'},
  {fuso: '6.00', value: '(GMT +6:00) Almaty, Dhaka, Colombo'},
  {fuso: '6.50', value: '(GMT +6:30) Yangon, Cocos Islands'},
  {fuso: '7.00', value: '(GMT +7:00) Bangkok, Hanói, Jacarta'},
  {fuso: '8.00', value: '(GMT +8:00) Beijing, Perth, Cingapura, Hong Kong'},
  {fuso: '9.00', value: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk'},
  {fuso: '9.50', value: '(GMT +9:30) Adelaide, Darwin'},
  {fuso: '10.00', value: '(GMT +10:00) Austrália Oriental, Guam, Vladivostok'},
  {fuso: '11.00', value: '(GMT +11:00) Magadan, Ilhas de Solomon, NovaCaledônia'},
  {fuso: '12.00', value: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka'}
]

export default fusos